// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loading-spinner_loadingSpinner__gGaQd","loadingSpin":"loading-spinner_loadingSpin__T5KPz"};